const sushiswap = require("./sushiswap");

const TOKEN_SYMBOL_TO_ADDRESS = {
  WFUSE: "0x0be9e53fd7edac9f859882afdda116645287c629",
  USDC: "0x620fd5fa44be6af63715ef4e65ddfa0387ad13f5",
  SUSHI: "0x90708b20ccc1eb95a4fa7c8b18fd2c22a0ff9e78",
  USDT: "0xfadbbf8ce7d5b7041be672561bba99f79c532e10",
};

const TOKEN_ADDRESS_TO_SYMBOL = Object.entries(TOKEN_SYMBOL_TO_ADDRESS).reduce((prev, curr) => ({
  ...prev,
  [curr[1]]: curr[0]
}), {});

const TOKEN_ADDRESS_TO_DECIMALS = {
  [TOKEN_SYMBOL_TO_ADDRESS.SUSHI]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.WFUSE]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.USDC]: 6,
  [TOKEN_SYMBOL_TO_ADDRESS.USDT]: 6,
};

const PREFERRED_SWAP_PATH_TOKEN_ADDRESS = TOKEN_SYMBOL_TO_ADDRESS.WFUSE;
const NATIVE_TOKEN = TOKEN_SYMBOL_TO_ADDRESS.WFUSE;

module.exports = {
  TOKEN_ADDRESS_TO_DECIMALS,
  TOKEN_SYMBOL_TO_ADDRESS,
  TOKEN_ADDRESS_TO_SYMBOL,
  PREFERRED_SWAP_PATH_TOKEN_ADDRESS,
  PROTOCOLS: {
    sushiswap
  },
  NATIVE_TOKEN,
};
